import Modal from "react-bootstrap/Modal";

const FolderDetail = (props) => {
    const { show, setShow, folder, setFolder } = props;

    const handleClose = () => {
        setShow(false);
        setFolder({});
    }

    return (
        <div>
            <Modal show={show} className="modal-common" onHide={handleClose}>
                <Modal.Header closeButton>Folder Details</Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="mb-30">
                            <label className="py-2">Folder Name</label>
                            <br />
                            <input
                                type="text"
                                className="form-control rounded-3 bg-cyan w-100"
                                name="title"
                                id="title"
                                value={folder?.title}
                                disabled
                            />
                        </div>
                        <div className="mb-30">
                            <label className="py-2">Google Drive Link</label>
                            <br />
                            <input
                                type="text"
                                className="form-control rounded-3 bg-cyan w-100"
                                name="link"
                                id="link"
                                value={folder?.link}
                                disabled
                            />
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default FolderDetail;
